import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalsModal');

    return {
        TITLE: t('title')
    };
};

export default useTranslation;
